import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-order-weight-block',
  templateUrl: './order-weight-block.component.html',
  styleUrls: ['./order-weight-block.component.scss'],
  standalone: false
})
export class OrderWeightBlockComponent {
  @Input() minimWeight!: number;
  @Input() totalWeight!: number;
}
